import { action } from 'typesafe-actions';
import { ECustomerTypeView } from '../user/types';
import { IFabricationContract, Types } from './types';
import { IConstructionData } from '../contracts-and-constructions/types';

export const loadContracts = (customerViewType: ECustomerTypeView) =>
  action(Types.LOAD_CONTRACTS, { customerViewType });
export const loadContractsV2 = () => action(Types.LOAD_CONTRACTS_V2);
export const loadContractsSuccess = (contracts: IFabricationContract[]) =>
  action(Types.LOAD_CONTRACTS_SUCCESS, { contracts });
export const loadContractsFailure = (error: unknown) =>
  action(Types.LOAD_CONTRACTS_FAILURE, { error });
export const loadOrderVersionReview = (
  contractNumber: string,
  gerdauOrderNumber: number,
  isRevision: boolean
) => ({
  type: Types.LOAD_ORDER_VERSION_REVIEW,
  payload: { contractNumber, gerdauOrderNumber, isRevision }
});
export const clearOrderVersionReview = () =>
  action(Types.CLEAR_ORDER_VERSION_REVIEW, {});
export const loadOrderVersionReviewSuccess = (contract: IFabricationContract) =>
  action(Types.LOAD_ORDER_VERSION_REVIEW_SUCCESS, { contract });
export const loadOrderVersionReviewFailure = (error: unknown) =>
  action(Types.LOAD_ORDER_VERSION_REVIEW_FAILURE, { error });

export const loadRequestNewOrder = (contractNumber: string) => ({
  type: Types.LOAD_REQUEST_NEW_ORDER,
  payload: { contractNumber }
});
export const loadRequestNewOrderSuccess = (contract: IFabricationContract) =>
  action(Types.LOAD_REQUEST_NEW_ORDER_SUCCESS, { contract });
export const loadRequestNewOrderFailure = (error: unknown) =>
  action(Types.LOAD_REQUEST_NEW_ORDER_FAILURE, { error });

export const loadContractDetails = (
  contractNumber: string,
  customerShipToId?: string
) => action(Types.LOAD_CONTRACT_DETAILS, { contractNumber, customerShipToId });
export const loadContractDetailsV2 = (contractNumber: string) =>
  action(Types.LOAD_CONTRACT_DETAILS_V2, { contractNumber });
export const loadContractDetailsSuccess = (
  contractNumber: string,
  contractDetails: IFabricationContract,
  constructionData: IConstructionData
) =>
  action(Types.LOAD_CONTRACT_DETAILS_SUCCESS, {
    contractNumber,
    contractDetails,
    constructionData
  });
export const loadContractDetailsFailure = (
  contractNumber: string,
  error: unknown
) => action(Types.LOAD_CONTRACT_DETAILS_FAILURE, { contractNumber, error });

export const loadContractByContractNumber = (contractNumber: string) =>
  action(Types.LOAD_CONTRACT_BY_CONTRACT_NUMBER, { contractNumber });
export const loadContractByContractNumberV2 = (contractNumber: string) =>
  action(Types.LOAD_CONTRACT_BY_CONTRACT_NUMBER_V2, { contractNumber });
export const loadContractByContractNumberSuccess = (
  contractDetails: IFabricationContract
) =>
  action(Types.LOAD_CONTRACT_BY_CONTRACT_NUMBER_SUCCESS, { contractDetails });
export const loadContractByContractNumberFailure = (error: unknown) =>
  action(Types.LOAD_CONTRACT_BY_CONTRACT_NUMBER_FAILURE, { error });

export const clearFabricationContracts = () =>
  action(Types.CLEAR_FABRICATION_CONTRACTS);
